<template>
  <hdraces-tickets-list :data-func="getTickets" :show-user="true" />
</template>
<script>
  import hdracesService from '../../../../services/hdraces.service'

  import hdracesTicketsList from '../../../common/hdraces-tickets-list.vue'

  export default {
    name: 'client-hdraces-bets',
    components: { hdracesTicketsList },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    methods: {
      async getTickets(filter) {
        filter.clientId = this.clientId;
        return await hdracesService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bets/hdraces-bets.vue